"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dropdownBackground = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var btnColor1 = '#f6f6f6';
var btnColor2 = '#f1f1f1';
var radius = 4;
var dropdownBackground = {
  background: '-webkit-linear-gradient(top, ' + btnColor1 + ' 0%,' + btnColor2 + ' 100%)',
  fallbacks: [{
    background: '' + btnColor1 + ''
  }, {
    background: '-moz-linear-gradient(top, ' + btnColor1 + ' 0%, ' + btnColor2 + ' 100%)'
  }, {
    background: 'linear-gradient(to bottom, ' + btnColor1 + ' 0%,' + btnColor2 + ' 100%)'
  }],
  filter: 'progid:DXImageTransform.Microsoft.gradient(' + "startColorstr='".concat(btnColor1, "', endColorstr='").concat(btnColor2, "',GradientType=0") + ')'
};
exports.dropdownBackground = dropdownBackground;

var makeStyle = function makeStyle() {
  return {
    '@global': {
      '.tether-dropdown': {
        zIndex: 1060
      },
      '.tether-dropdown > div.stilo-bootstrap.open.btn-group > ul.dropdown-menu': {
        maxHeight: 200
      }
    },
    Dropdown: {
      minWidth: 152,
      display: 'flex',
      flex: 1,
      '&.disable-flex': {
        minWidth: 'auto',
        '& div.dropdown': {
          minWidth: 'auto'
        }
      },
      '& div.dropdown': {
        border: 'none',
        borderRadius: radius,
        marginBottom: 10,
        minWidth: 152,
        '& button.btn.dropdown-toggle.btn-default': _objectSpread(_objectSpread({
          border: '1px #dcdcdc solid',
          paddingRight: '30px',
          width: 'auto'
        }, dropdownBackground), {}, {
          textAlign: 'left',
          '& span': {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            right: 10
          },
          borderRadius: radius
        }),
        '&.btn-group.open .dropdown-menu': {
          'min-width': '100%',
          'max-height': '200px',
          'overflow-y': 'auto',
          zIndex: 1020
        },
        '&.btn-group': {
          '& .btn': {
            'display': 'flex',
            'align-items': 'center',
            'padding-right': '6px',
            'justify-content': 'space-between',
            maxWidth: '100%',
            '& .dropdown-label': {
              flexShrink: 1
            },
            '& .dropdown-label, .title': {
              overflow: 'hidden'
            },
            '& .caret': {
              'margin': '0px 3px 0px 6px'
            }
          }
        }
      },
      '& .dropdown-menu .checkbox': {
        'margin-top': '4px',
        'margin-bottom': '4px'
      },
      '& .dropdown-menu .select-all label': {
        'font-weight': 'bold'
      },
      '& .dropdown-menu .search-field': {
        'padding-left': '8px',
        'padding-right': '8px'
      },
      // Remove button styles
      '& .inputRemoveButton:active': {
        'box-shadow': 'none',
        'outline': 'none'
      },
      '& .inputRemoveButton:focus': {
        'box-shadow': 'none',
        'outline': 'none'
      },
      '& .inputRemoveButton': {
        'border-top-right-radius': '4px',
        'border-bottom-right-radius': '4px',
        'background-color': '#FF997F',
        'width': '32px',
        'max-height': '34px',
        display: 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'center',
        'border': '0px',
        'overflow': 'hidden',
        'cursor': 'default',
        '& .minusGlyph': {
          'font-size': '40px',
          'color': 'white',
          'margin-top': '4px'
        }
      },
      '&.dropdown-multi .dropdown-menu > li > a': {
        padding: '5px 10px',
        '& .checkbox': {
          paddingTop: 0
        }
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map